<template>
  <div class="widget-video web-video-xd">
    <div ref="xdvideo" class="web-video-xd" :data-options="optionsStr" />
    <canvas v-if="needHack" width="0" height="0" style="display: none"></canvas>
    <!-- <ImageMask v-if="imageMask.enabled" :image-mask="imageMask" /> -->
  </div>
</template>
<script>
import Vue from 'vue'
import * as api from '@/service/index'
import { mapState, mapMutations } from 'vuex'
// import ImageMask from '../default/image-mask.vue';

export default {
  name: 'WidgetVideoNuxt',
  props: {
    feedBackStatus: {
      type: Function,
      default: () => {}
    },
    liveInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      needHack: false,
      pid: '',
      player: null,
      options: {
        controls: true,
        loop: true,
        poster: '',
        muted: true,
        autoplay: true,
        scrollAutoPlay: false,
        autoFullScreen: false,
        preload: false
      },
      widgetClassName: 'widget-video',
      status: false,
      pictureInPictureToggle: false,
      sourceType: '', // video/mp4  application/x-mpegURL
      localePath: [],
      wantStatus: {
        play: false,
        loop: true,
        fullScreen: false
      },

      time: {
        play: '',
        pause: ''
      },
      timerCount: 1,
      timer: null,
      closeTimer: true,
      // 状态锁
      isUpdating: false,
      // 已获取到的时间戳
      countMiles: 0
    }
  },
  computed: {
    ...mapState(['fullScreen', 'token', 'userInfo','amount']),
    sources() {
      let result = []
      const { localePath, sourceType } = this
      localePath.map(({ key, value }) => {
        if (key !== 'poster' && value) {
          result.push({
            label: key.toUpperCase(),
            src: value,
            type: sourceType
          })
        }
      })
      return result
    },

    optionsStr() {
      return JSON.stringify({ ...this.options, sources: this.sources })
    }
  },
  watch: {
    poster() {
      if (this.player) {
        this.player.poster(this.poster)
      }
    },
    sources(newVal) {
      if (this.player) {
        this.player.VideoControl().updateNormalSource(newVal)
      }
    },
    liveInfo: {
      handler(newVal) {
        const { screenshot, ld, hd, fhd, type } = newVal
        this.options.poster = screenshot

        let arr = [
          { key: 'ld', value: ld },
          { key: 'hd', value: hd },
          { key: 'fhd', value: fhd },
          { key: 'poster', value: screenshot }
        ]
        this.localePath = arr

        this.sourceType = type
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // 添加任意 canvas 或者视频宽度在 [21, 179] 之间时，qq x5 浏览器 在 vivo 手机上可以隐藏控件
    if (!window.__XDVIDEO__) {
      // const { CONSTANT } = window.moo;
      // if (CONSTANT.IS_ANDROID && CONSTANT.IS_BROWSER_QQ) this.needHack = true;
      (function (w, d, t, r) {
        w['__WEB_VIDEO_OBJECT__'] = r
        w[r] =
          w[r] ||
          function () {
            (w[r].cmd = w[r].cmd || []).push(arguments)
          }
        var n = d.createElement(t),
          m = d.getElementsByTagName(t)[0]
        var j = d.createElement('link')
        j.rel = 'stylesheet'
        j.type = 'text/css'
        j.href = 'https://res.xdcdn.net/video/xdvideo-player.css'
        m.parentNode.insertBefore(j, m)
        n.async = 1
        n.src = 'https://res.xdcdn.net/video/xdvideo-player.min.js'
        m.parentNode.insertBefore(n, m)
      })(window, document, 'script', '__XDVIDEO__')
    }
    window.__XDVIDEO__('register', {
      pick: this.$refs.xdvideo,
      afterCreate: this.handleAfterCreate,
      onError: (e) => {
        console.log(e)
      }
    })
  },
  methods: {
    ...mapMutations(['SET_FULLSCREEN']),
    play() {
      if (this.status) return
      if (!this.player) return
      this.player.autoplay('any')
    },
    pause() {
      this.player && this.player.pause()
    },
    handleAfterCreate(videojs) {
      let pid = videojs.getPid(this.$refs.xdvideo)
      if (pid === this.pid) return
      this.pid = pid
      this.player = videojs.getPlayer(pid)
      if (!this.player) return
      // this.rocketEmit('rocket:video:ready', true);
      this.videoReady()
      this.player.on('playing', () => this.updateStatus())
      // 暂停视频不在上报时间
      // this.player.on('pause', () => this.updateStatus());
      this.player.on('ended', () => {
        // this.rocketEmit('rocket:video:ended', true);
      })
      this.player.on('fullscreenchange', (e) => this.handleFullscreenChange(e))
      this.player.on('error', () => this.feedBackStatus(2, false))
      // 在初始化完成之前执行的动作，进行补救
      if (this.wantStatus.play && !this.options.autoplay) {
        this.play()
      }
      if (this.wantStatus.fullScreen) {
        this.player.requestFullscreen()
      }
      if (this.wantStatus.loop !== this.options.loop) {
        this.player.loop(this.wantStatus.loop)
      }
    },
    updateStatus() {
      // console.log('updateStatus',this.isUpdating);
      if (!this.isUpdating) {
        // console.log('updateStatus1',this.isUpdating);
        this.isUpdating = true
        this.timer = setInterval(() => {
          // 每次执行15次，且需要在要直播页，且观看时间小于120分钟
          if (this.timerCount <= 120 && this.closeTimer && this.countMiles < 120) {
            // TODO 按钮暂停，需停止定时器。 播放在开始定时器
            // 当前播放器的状态
            let status = !this.player.paused()
            // 说明当时在播放
            if (status !== this.status) {
              // console.log('我在播放');
              // this.initTime();
              this.reportMinutes()
              this.timerCount++
            } else {
              // this.isUpdating = false;
              clearInterval(this.timer)
            }
          } else {
            clearInterval(this.timer)
          }
          this.isUpdating = false
        }, 60000)
      }
      // 被执行了两次
    },
    handleFullscreenChange() {
      // this.rocketEmit(
      //   'rocket:video:fullscreenchange',
      //   true,
      //   this.player.isFullscreen()
      // );
    },
    initTime() {
      // 初始化时间戳
      api.reqcurrentTime().then((response) => {
        if (response.status == 200) {
          this.time.play = response.data
        }
      })
    },
    reportMinutes() {
      // console.log('this.time.play',this.time.play);
      // if (this.time.play != "") {
      // }
      api
        .reqcurrentTime()
        .then((response) => {
          // console.log('response',response);
          if (response.status == 200) {
            // this.time.pause = response.data;
            // 观看1分钟以上为有效数据
            let data = {
              minutes: 1
              // token: decodeURIComponent(),
            }
            // console.log('data',data);
            let token = this.token
            // console.log('观看成功');
            api.reportMinutes(token, data)

            // 埋点
            if (typeof tapdb == 'undefined') return
            tapdb.trackEvent('观看直播', {
              '#duration': 1
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleFullScreen() {
      this.SET_FULLSCREEN(!this.fullScreen)
    },
    videoReady() {
      let self = this
      const $controlBar = document.getElementsByClassName(
        'vjs-control-bar-right'
      )[0]
      const app = Vue.extend({
        methods: {
          fn() {
            self.handleFullScreen()
          }
        },
        template:
          '<div class="vjs-live-fullscreen-control" @click="fn"><i></i></div>'
      })
      let liveFullScreen = new app().$mount()
      $controlBar.append(liveFullScreen.$el)
    },
    async fetchUserInfo() {
      if(!this.token) return;
      try {
        const req = await api.reqUserInfo({ token: this.token ,force: true})
        this.countMiles = req.data.viewTime
      } catch (err) {
        console.log(err)
      }
    }
  },
  created() {
    this.fetchUserInfo()
  },
  beforeDestroy() {
    this.closeTimer = false
  }
}
</script>
<style lang="scss" scoped>
.web-video-xd {
  height: 100%;
  background: transparent;
  padding: 0;
  flex-grow: 1;
  ::v-deep video {
    object-fit: var(--rocket-video-object-fit, contain);
    outline: none;
  }
}
.widget-video {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  flex-direction: column;
  &.rocket-video-without-pip {
    ::v-deep .vjs-picture-in-picture-control {
      display: none;
    }
  }
  ::v-deep .video-js {
    background-color: transparent;
    .vjs-modal-dialog {
      background: transparent;
    }
    &.vjs-controls-disabled {
      .vjs-loading-spinner,
      .vjs-error-display {
        display: none;
      }
    }
    .vjs-time-control {
      display: none;
    }

    .vjs-control-bar {
      // height: get_vh(64px) !important;
      background-color: rgba(31, 31, 31, 0.5);
      .vjs-live-control {
        .vjs-live-display {
          display: none;
        }
      }
      .vjs-audio-button,
      .vjs-at-live-edge,
      .vjs-seek-to-live-control,
      .vjs-fullscreen-control,
      .vjs-picture-in-picture-control {
        display: none;
      }

      .vjs-live-fullscreen-control {
        position: relative;
        width: 40px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          display: inline-block;
          @include sprite_bg('live_full');
          width: 22px;
          height: 22px;
        }
      }
    }

    .vjs-error-display {
      display: none;
    }
  }
  .vjs-poster {
    background-size: cover;
  }
  &.rocket-video-playing {
    ::v-deep .image-mask {
      display: none;
    }
  }
}
</style>
